import { Fragment, useEffect } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import { Breadcrumbs } from "AbstractElements";
import TheForm from "Components/Common/Component/form/TheForm";
import { useCrudApi } from "hook/useCrudApi";
import { useResourceNavigate } from "hook/useResourceNavigate";
import { LichSuThanhToan } from "models/lich-su-thanh-toan";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import { useFormFields, parent, title } from "./constant";
import { formatDetailPage } from "_helper/utils";
import { useTrangThaiThanhToan } from "hook/useTrangThaiThanhToan";

export const DetailPage = () => {
  const { useGetById } = useCrudApi<LichSuThanhToan>("LichSuThanhToan");
  const { toList, toEdit } = useResourceNavigate("lich-su-thanh-toan");

  const { id } = useParams();

  const { data, isFetched } = useGetById(id ?? "");

  const { formFields } = useFormFields();
  const useFormReturn = useForm();
  const { reset } = useFormReturn;

  const { data: trangThai } = useTrangThaiThanhToan();

  useEffect(() => {
    reset({
      ...formatDetailPage(data),
      trangThai: trangThai?.find((item) => item.value === data?.trangThai)?.name,
    });
  }, [data, isFetched]);

  return (
    <Fragment>
      <Breadcrumbs title={title} parent={parent} mainTitle={title} />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <TheForm
                  {...useFormReturn}
                  items={formFields}
                  textOnly
                  onEdit={() => toEdit(id!)}
                  onCancel={toList}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
